export const EXAMEN_CATEGORIES = Object.freeze([
    { value: 'radiographie', label: 'Radiographie' },
    { value: 'echographie', label: 'Echographie' },
    { value: 'scanner', label: 'Scanner' },
    { value: 'irm', label: 'IRM' },
    { value: 'mammographie', label: 'Mammographie' },
    { value: 'explorations_fonctionnelles', label: 'Explorations fonctionnelles' }
])

export function libelleCategorieExamen(code) {
    const categorie = EXAMEN_CATEGORIES.find(item => item.value === code)
    return categorie ? categorie.label : 'À classer'
}

export function grouperExamens(examens) {
    const groupes = EXAMEN_CATEGORIES.map(item => ({ id: item.value, nom: item.label, items: [] }))
    const nonClasses = { id: 'non_classes', nom: 'À classer', items: [] }
    const index = new Map(groupes.map(groupe => [groupe.id, groupe]))
    ;(Array.isArray(examens) ? examens : []).forEach(examen => {
        // Preserve the original object, identifiers, price and selection metadata.
        const groupe = index.get(examen.categorie) || nonClasses
        groupe.items.push(examen)
    })
    return groupes.concat(nonClasses).filter(groupe => groupe.items.length)
}
